import { IState } from '../../../store/reducer';

const LEGACY_ADJUSTMENT_REASON = 'legacy';

/**
 * Selector to determine if a customer is on the "legacy" commission model.
 * @param state {IState} - The Redux store current state.
 * @param customerId {string} - The customer to check.
 * @returns {boolean | undefined} true if legacy, false is not, or undefined if we couldn't determine.
 */
export const customerIsLegacyCommission = (state: IState, customerId: string): boolean | undefined => {
	const customerCommission = state?.data?.commission?.byCustomer[customerId];

	if (!customerCommission) {
		return undefined;
	}

	return customerCommission.adjustments.find((adj) => adj.reason === LEGACY_ADJUSTMENT_REASON) !== undefined;
};
